import { Link } from "react-router-dom";
import { img, rm } from "../../lib/api";
import { useLang } from "../../lib/ctx";
import { CONDITION_KEY } from "../../lib/i18n";

export const ConditionBadge = ({ c }) => {
  const { t } = useLang();
  const gold = ["vintage_preowned", "retro"].includes(c);
  return <span className={`px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest ${gold ? "bg-[#C8A45D] text-black" : "bg-black/70 text-white border border-white/20"}`}>{t(CONDITION_KEY[c] || "new")}</span>;
};

export const ProductCard = ({ p, i = 0 }) => {
  const { pick, t } = useLang();
  return (
    <Link to={`/product/${p.slug}`} className="group block rise" style={{ animationDelay: `${i * 60}ms` }} data-testid={`product-card-${p.slug}`}>
      <div className="relative aspect-[4/5] overflow-hidden bg-[#141414]">
        <img src={img(p.images?.[0]?.url)} alt={p.images?.[0]?.alt || p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute left-3 top-3 flex gap-1"><ConditionBadge c={p.condition} />{p.one_of_one && <span className="bg-white px-2 py-0.5 font-mono text-[10px] uppercase text-black">1 of 1</span>}</div>
        {p.promo && <span className="absolute right-0 top-0 bg-[#ee4d2d] px-2 py-1 text-[11px] font-bold text-white" data-testid="product-card-promo">-{p.promo.pct}%</span>}
        {!p.in_stock && <div className="absolute inset-0 grid place-items-center bg-black/60 font-display text-3xl tracking-widest">{t("soldOut")}</div>}
      </div>
      <div className="mt-3 flex items-start justify-between gap-3">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{p.brand}</p>
          <h3 className="mt-1 text-sm font-semibold leading-snug transition-colors duration-200 group-hover:text-[#C8A45D]">{pick(p, "title")}</h3>
        </div>
        <div className="text-right">
          <p className="whitespace-nowrap font-semibold text-[#C8A45D]" data-testid="product-card-price">{rm(p.price_from)}</p>
          {p.compare_at && <p className="whitespace-nowrap text-xs text-zinc-500 line-through">{rm(p.compare_at)}</p>}
        </div>
      </div>
    </Link>
  );
};

export const ProductGrid = ({ items, testid = "product-grid" }) => (
  <div className="grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 lg:grid-cols-4" data-testid={testid}>
    {items.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
  </div>
);

export const SectionHead = ({ eyebrow, title, to, cta }) => (
  <div className="mb-10 flex items-end justify-between gap-4">
    <div>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="mt-2 font-display text-4xl sm:text-5xl">{title}</h2>
    </div>
    {to && <Link to={to} className="border-b border-[#C8A45D] pb-1 text-xs font-semibold uppercase tracking-widest text-[#C8A45D]" data-testid={`view-all-${to.replace(/\//g, "-")}`}>{cta}</Link>}
  </div>
);
